export enum PaymentMethod{
    Cash = 1,
    BankTransfer = 2,
    MBWay = 3,
    InKind = 4
}
